import React, { useEffect } from 'react';
import { Grid, Typography, InputLabel, FormHelperText, Box, IconButton, Chip, Avatar, FormControlLabel } from '@material-ui/core';
import { SecondaryButton, TextBox, Dialogs, DialogTitles, DialogContents, DialogsActions, SecondaryCheckbox } from '../../../../Core/FormInput/index';
import { useState } from 'react';
import { getVehicleStatusID, Job_UpdateJobDescription, getJobDescription } from '../../../../Core/Service/communicator-service';
import { useContext } from 'react';
import AppContext from '../../../../App/AppContext';
import CloseIcon from '@material-ui/icons/Close';

const JobDescModal = (props) => {
    const { showToast, showModal, userRoles } = useContext(AppContext);
    const { onClose } = props;
    const [state, setState] = useState({
        errors: {},
        workDetails: '',
        reg: '',
        wip: '',
        chassisNumber: '',
        chassisNumber2: '',
        isNightShift: null
    });

    const handleInput = (e) => {
        const { name, value } = e.target;

        setState((st) => ({ ...st, [name]: value }));
    };
    const handleCheckbox = (e, a) => {
        setState((st) => ({ ...st, [e.target.name]: a }));
    };

    const validation = () => {
        let { workDetails } = state;
        let isValid = true;
        let errors = {};

        if (!workDetails) {
            isValid = false;
            errors.workDetails = 'Work Details is required';
        }
        setState((st) => ({ ...st, errors: errors }));
        return isValid;
    };

    useEffect(async () => {
        let res = await getJobDescription(props.headerRecordID);
        if (res.success) {
            let details = res?.data?.list?.table[0];
            setState((st) => ({
                ...st,
                chassisNumber: details.chassisNumber,
                chassisNumber2: details.chassisNumber2,
                reg: details.registration,
                wip: details.wipNumber,
                workDetails: details.workDetails,
                isNightShift: details.isNightShift
            }));
        }
    }, [props.headerRecordID]);

    const handleSubmit = async () => {
        if (validation()) {
            let data = {
                headerRecordID: props.headerRecordID,
                workDetails: state.workDetails,
                chassisNumber2: state.chassisNumber2,
                isNightShift: state.isNightShift
            };
            let res = await Job_UpdateJobDescription(data);
            if (res.success) {
                showToast(res.message);
                props.onClose(true, state.workDetails);
            } else {
                showToast(res.message);
            }
        }
    };

    const addActionLogHeaderComp = (ModalTitle) => {
        return (
            <Grid container>
                <Grid item>
                    <span>Job Description</span>
                </Grid>
            </Grid>
        );
    };

    return (
        <Dialogs open={true} onClose={() => props.onClose(false, null)} maxWidth="lg" width="300px">
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>{<DialogTitles>{addActionLogHeaderComp()}</DialogTitles>}</Box>
                <Box>
                    <IconButton onClick={() => props.onClose(false, null)}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <DialogContents className="hiddenScroll" style={{ width: '700px' }}>
                <Grid item style={{ fontSize: 15, textAlign: 'left' }}>
                    WIP No:&nbsp; <b> {state.wip}</b> &nbsp;&nbsp; Reg. No:&nbsp; <b> {state.reg}</b> &nbsp;&nbsp; Chassis Number: &nbsp;{' '}
                    <b>{state.chassisNumber}</b> &nbsp;&nbsp;
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputLabel shrink error>
                            Job Description
                        </InputLabel>
                        <TextBox
                            placeholder="Job Description"
                            id="outlined-multiline-static"
                            multiline
                            rows={6}
                            variant="outlined"
                            name="workDetails"
                            value={state.workDetails}
                            onChange={handleInput}
                            disabled={state.isReadOnly}
                            autoFocus={true}
                        />
                        <FormHelperText error>{state.errors.workDetails}</FormHelperText>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <InputLabel shrink error>
                            2nd Chassis Number
                        </InputLabel>
                        <TextBox
                            placeholder="2nd Chassis Number"
                            variant="outlined"
                            name="chassisNumber2"
                            value={state.chassisNumber2}
                            onChange={handleInput}
                            inputProps={{ maxLength: 30 }}
                        />
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: '15px' }}>
                        <FormControlLabel
                            control={<SecondaryCheckbox checked={state.isNightShift} onChange={handleCheckbox} name="isNightShift" />}
                            label="Is Nightshift Job?"
                        />
                    </Grid>
                </Grid>
            </DialogContents>
            {!state.isReadOnly && (
                <DialogsActions className="dialogActions">
                    <Grid item xs={6}>
                        <SecondaryButton className="Submitbtn" fullWidth onClick={handleSubmit} disabled={state.isReadOnly}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                    <Grid item xs={6}>
                        <SecondaryButton className="Submitbtn" fullWidth onClick={() => onClose(false, null)}>
                            Cancel
                        </SecondaryButton>
                    </Grid>
                </DialogsActions>
            )}
        </Dialogs>
    );
};

export default JobDescModal;
